import React, { useState } from "react";
import { Mail, Linkedin, ArrowUpRight, Send } from "lucide-react";

const TO_EMAIL = "etharunsai9@gmail.com";
const LINKEDIN_URL = "https://www.linkedin.com/in/tharunsaierukulla";
const SENT_TOAST_DURATION_MS = 4000;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    const subject = encodeURIComponent("Hello Tharun — from your portfolio");
    const body = encodeURIComponent(
      `Hi Tharun,\n\n${message || "I came across your portfolio and wanted to connect."}\n\n— Sent from: ${email}`
    );
    // Opens user's mail client with recipient & message prefilled
    window.location.href = `mailto:${TO_EMAIL}?subject=${subject}&body=${body}`;
    setSent(true);
    setTimeout(() => setSent(false), SENT_TOAST_DURATION_MS);
    setEmail("");
    setMessage("");
  };

  return (
    <footer
      id="contact"
      className="relative bg-[#0F0F10] text-[#FFF8E7] rounded-t-[40px] px-4 sm:px-6 lg:px-10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 pb-16 border-b border-white/10">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFE357] font-semibold mb-3">
              Let's build something
            </div>
            <h2 className="text-5xl sm:text-7xl font-extrabold tracking-tight leading-[0.95]">
              Got a product
              <br />
              <span className="text-[#FFE357]">to ship?</span>
            </h2>
            <p className="mt-6 text-lg text-white/70 max-w-md">
              I love working on products that make humans happier, healthier or wiser. Drop your email below — I'll get back within 24 hours.
            </p>

            <form onSubmit={submit} className="mt-8 flex flex-col gap-2 max-w-md">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="px-5 py-3 rounded-2xl bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-[#FFE357]"
              />
              <textarea
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="A line about what you'd like to build (optional)"
                className="px-5 py-3 rounded-2xl bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-[#FFE357] resize-none"
              ></textarea>
              <button
                type="submit"
                className="self-start mt-1 px-5 py-3 rounded-full bg-[#FFE357] text-[#0F0F10] font-semibold flex items-center gap-2 hover:bg-[#FFD93D] transition-colors"
              >
                {sent ? "Opening your mail app…" : "Send"}
                <Send className="w-4 h-4" />
              </button>
              <p className="text-xs text-white/40 mt-1">
                This opens your mail client with a draft to {TO_EMAIL}.
              </p>
            </form>
          </div>

          <div className="flex flex-col gap-6">
            <a
              href={`mailto:${TO_EMAIL}`}
              className="group flex items-center justify-between p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="w-10 h-10 rounded-full bg-[#FFE357] text-[#0F0F10] grid place-items-center">
                  <Mail className="w-5 h-5" />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-widest text-white/50">Email</div>
                  <div className="font-semibold break-all">{TO_EMAIL}</div>
                </div>
              </div>
              <ArrowUpRight className="w-5 h-5 group-hover:rotate-45 transition-transform" />
            </a>

            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="w-10 h-10 rounded-full bg-[#FFE357] text-[#0F0F10] grid place-items-center">
                  <Linkedin className="w-5 h-5" />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-widest text-white/50">LinkedIn</div>
                  <div className="font-semibold">www.linkedin.com/in/tharunsaierukulla</div>
                </div>
              </div>
              <ArrowUpRight className="w-5 h-5 group-hover:rotate-45 transition-transform" />
            </a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-sm text-white/50">
          <div>© {new Date().getFullYear()} Tharun Sai. All rights reserved.</div>
          <div className="font-mono text-xs">Crafted with care · Plus Jakarta Sans</div>
        </div>

        <div className="mt-12 overflow-hidden">
          <div className="flex gap-12 whitespace-nowrap animate-marquee text-[14vw] font-extrabold tracking-tighter text-[#FFE357]/10 leading-none">
            <span>THARUN SAI · PRODUCT MANAGER · BUILDER ·</span>
            <span>THARUN SAI · PRODUCT MANAGER · BUILDER ·</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
